import GeneralInformationForm from './GeneralInformationForm';

export default GeneralInformationForm;
